import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import Img from '../Img';
import { classIf } from '../../data/utils';

export default function SystemTuples(props) {
    const betslipContext = useContext(BetslipContext) ;
    const betslipData = betslipContext.getBetslipData();
    const couponKey = props.couponKey;
    const container = props.container;
    
    const coupon = betslipData.coupons[couponKey];
    const bankedSelNum = coupon.bankedSelNumber;
    let userSystemSelections = coupon.userSystemSelections;
    let combinations = coupon.calculatedSystemData.comb;
    
    if (combinations == null) {
        combinations = [];
    }
    
    function toggleCombs(indexComb) {
        betslipContext.setGeneralStake(null, indexComb);
    }
    
    let atLeastOneTuple = false;
    for (let ks in userSystemSelections) {
        atLeastOneTuple = atLeastOneTuple || userSystemSelections[ks].selected;
        if (atLeastOneTuple) {
            break;
        }
    }
    
    /** SPIEGAZIONE GIOCATE SISTEMISTICHE: 
    	Bisogna sempre pensare al sistema come una modalità per giocare più "multiple" insieme.
    	se su 3 esiti seleziono le comb 1/3 significa che sto giocando tutte le combinazioni
        da 1. Cioè è come se giocassi i 3 esiti su 3 biglietti differenti. La vincita potenziale è la somma delle 3 vincite potenziali,
        la Vin.Min è il "biglietto" dei 3 che vince di meno, la Vin.Max invece è quello che vince di più. 
        Se gioco invece la 2/3 sto giocando tutte le combinazioni da 2 su un insieme di 3 (anche in questo caso, sono 3 "biglietti"). 
        Vale lo stesso discorso: espongo la vincita come somma di tutti i "biglietti" vincenti, la minima come il biglietto che vince di meno, la massima come quello che vince di più.
        NB: se il cliente ha solo i sistemi integrali, allora non è possibile giocare più esiti sullo stesso evento.
        Significa che le vincite esposte sono veritiere (nel senso che vengono tradotte in multiple che non si "contraddicono" l'un l'altra).
        Nel caso contrario, dipende dal tipo di esito scelto. Ad esempio 1 e X non potranno mai tradursi in multiple entrambe vincenti, ma questo
        controllo non e' fattibile farlo a priori sul frontend.
        Quando si inserisce una selezione fissa, elimino dalle combinazioni selezionabili quelle che generano il biglietto con l'unica selezione fissa.
        (e' sempre la prima valida nel vettore). Se ne aggiungo un'altra, elimino quelle che generano l'unico biglietto con le due fisse selezionate, e così via.
        
        
        */
    
    // const stakeTaxedForPurchase = betslipContext.stakeTaxConfiguration.enabled && 
    //   							  betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase';
    
    return (
        <div className="b_10">
            {combinations.map(function(combination, index) {         	
                let drawNumberForThisComb = index;
                let totalDraws = coupon.totalDraws;
                let drawTuple = combination > 0;

                if (bankedSelNum > 0) {
                    if (bankedSelNum == index) {
                        drawTuple = false;
                    } else {
                        drawNumberForThisComb = `F${bankedSelNum} ${index - bankedSelNum}`;
                        totalDraws = totalDraws - bankedSelNum;         		
                    }
                    
                }

                if (drawTuple) {
                    const reactCombKey = 'system-tuples-coupon-' + couponKey + '-container-' + container + "-tuple-" + index;
                    const active = userSystemSelections[index].selected;
                    return (
                        <React.Fragment key={reactCombKey}>
                            <div className="b_10_1 pointer" onClick={() => toggleCombs(index)}>
                                <Img className={"b_10_1_1" + classIf(active, 'active')} src={active ? "checkbox.svg" : "checkbox_default.svg"} height="16px" width="16px" />
                                <div className="b_10_1_2">{`${drawNumberForThisComb}/${totalDraws}`}</div>
                            </div>
                        </React.Fragment>
                    );
                    
                }

                return null;
            })}       
        </div>
    );
}
